import * as Cesium from 'cesium';

export function mmToPx(mm): number {
  return mm * 3.7795275591;
}

export function capitalize(str: string): string {
  return str[0].toUpperCase() + str.substring(1);
}


export function stringPositionToObject(stringPosition: string): { x: any, y: any } {
  const coords = stringPosition.split(',');

  return {
    x: Number(coords[0]),
    y: Number(coords[1])
  };
}

export function convertDimensionWithRatio(from: number[], to: number[], stringPosition: string): any {
  if (!stringPosition) {
    return
  }

  const position = stringPositionToObject(stringPosition);

  const [fromW, fromH] = from;
  const [toW, toH] = to;

  const wRatio = fromW / toW;
  const hRatio = fromH / toH;

  const convertedPos = {
    x: position.x / wRatio,
    y: position.y / hRatio
  };

  return convertedPos
}

export const sortPriority = (priority) => {
  switch (priority) {
    case 'Elevée':
      return 1;
    case 'Moyenne':
      return 2;
    case 'Faible':
      return 3;
    default:
      return 4;
  }
}

export function toDegrees(cartesian3Pos) {
  let pos = Cesium.Cartographic.fromCartesian(cartesian3Pos)
  return [pos.longitude / Math.PI * 180, pos.latitude / Math.PI * 180]
}


export function pointInsideBbox(points, bbox): boolean {
  const [minX, minY, maxX, maxY] = bbox;
  const [x, y] = points.map((a) => Number(a));

  return x >= minX && x <= maxX && y >= minY && y <= maxY;
}


export function isPointOn3dScreen(viewer: Cesium.Viewer, point: Cesium.Entity) {
  const screenPosition = Cesium.SceneTransforms.worldToWindowCoordinates(
    viewer.scene, point.position.getValue(viewer.clock.currentTime)
  );

  if (!screenPosition) {
    return false;
  }

  const canvas = viewer.scene.canvas;
  return (
    screenPosition.x >= 0 &&
    screenPosition.x <= canvas.width &&
    screenPosition.y >= 0 &&
    screenPosition.y <= canvas.height
  );
}

export function getVisiblePoints(viewer: Cesium.Viewer, entities: any): any[] {

  const points = [];

  Array.from(entities.values()).forEach((entity: any) => {
    if (!entity.points) {
      return;
    }

    points.push(...entity.points);
  });

  // Filtrer les points visibles
  return Array.from(new Set(points.filter((p) => isPointOn3dScreen(viewer, p)).map((point) => {
    return Number(point.properties.getValue()?.num);
  })));
}

export function isENJEUX(properties): boolean {
  // TODO: normaliser les features issus des plan/pcs

  if (properties?.type_picto === 'ENJEU') {
    // PAS
    return true;
  } else if (properties?.type_pcs === 'enjeux') {
    // PCS
    return true;
  }

  return false;
}

export function getIconSize(viewer: Cesium.Viewer): number {
  if (viewer.scene.mode === Cesium.SceneMode.SCENE2D) {
    return Number(localStorage.getItem('pointSize-2d')) || 60;
  } else {
    return Number(localStorage.getItem('pointSize-3d')) || 40;
  }
}

export function setIconSize(viewer: Cesium.Viewer, iconSize: number): void {
  if (viewer.scene.mode === Cesium.SceneMode.SCENE2D) {
    localStorage.setItem('pointSize-2d', iconSize.toString());
  } else {
    localStorage.setItem('pointSize-3d', iconSize.toString());
  }
}

export const DIMENSION_PRINT_2D_HEIGHT = 9921;
export const DIMENSION_PRINT_2D_WIDTH = 13465;

export const INITIAL_PRINT_POSITION = {
  MODULE_CUSTOM: '3544,0',
  TITLE: '7000,500',
  ZOOM_1: '0,2835.4218',
  ZOOM_2: '0,6378.2118',
  MODULE_LEGENDE_STATIC: '0,0',
  MODULE_STRATEGIE_ALERTE_COMMUNALE: '0,1382.4793046357615',
};

export const ENTITY_Z_ORDER = {
  TITLE: 5,
  LEGEND: 4,
  LABEL: 3,
  MODULE_CUSTOM: 2,
  ZOOM: 1,
};

export function getContainerDimension(viewer): {width: number, height: number}  {
  return {
    width: Number(viewer.container.style.width.replace('px', '')),
    height: Number(viewer.container.style.height.replace('px', ''))
  };
}
